export default {"src":"/_next/static/media/ship-sticks.3f6019e9.svg","height":24,"width":49,"blurWidth":0,"blurHeight":0};